import { type OperatorNode, type AstNode } from "./types";

export const evaluateAst = (
  ast: AstNode,
  data?: Record<string, number>,
): number => {
  if (ast.type === "number") {
    const parsedNumber = parseFloat(ast.value);
    if (!Number.isNaN(parsedNumber)) {
      return parsedNumber;
    } else {
      throw new Error("Invalid operand: " + ast.value);
    }
  } else if (ast.type === "variable") {
    let value = 0;
    if (data) {
      if (ast.value.startsWith("northbeam_custom_")) {
        const variable = ast.value.replace("northbeam_custom_", "");
        value = Number(data[variable]);
      } else {
        value = Number(data[ast.value]);
      }
    }

    if (Number.isNaN(value)) {
      return 0;
    }

    return value;
  } else if (ast.type === "operator") {
    const leftValue = evaluateAst(ast.left, data);
    const rightValue = evaluateAst(ast.right, data);

    switch (ast.value) {
      case "+":
        return leftValue + rightValue;
      case "-":
        return leftValue - rightValue;
      case "*":
        return leftValue * rightValue;
      case "/":
        if (leftValue === 0 && rightValue === 0) {
          return 0;
        } else if (rightValue === 0) {
          return Infinity;
        }
        return leftValue / rightValue;
      default:
        throw new Error("Invalid operator: " + (ast as OperatorNode).value);
    }
  } else {
    throw new Error("Invalid AST node type: " + (ast as AstNode).type);
  }
};
